/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_DisabledInputs */

const en_team_manager_disabled = /** @type {(inputs: Team_Manager_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const fr_team_manager_disabled = /** @type {(inputs: Team_Manager_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactivé`)
};

const de_team_manager_disabled = /** @type {(inputs: Team_Manager_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deaktiviert`)
};

const it_team_manager_disabled = /** @type {(inputs: Team_Manager_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabili`)
};

const ru_team_manager_disabled = /** @type {(inputs: Team_Manager_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неполноценный`)
};

const es_team_manager_disabled = /** @type {(inputs: Team_Manager_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desactivado`)
};

const zh_cn2_team_manager_disabled = /** @type {(inputs: Team_Manager_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已禁用`)
};

const ja_team_manager_disabled = /** @type {(inputs: Team_Manager_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効`)
};

const hi_team_manager_disabled = /** @type {(inputs: Team_Manager_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अक्षम`)
};

const pt_pt2_team_manager_disabled = /** @type {(inputs: Team_Manager_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desabilitado`)
};

/**
* | output |
* | --- |
* | "Disabled" |
*
* @param {Team_Manager_DisabledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_disabled = /** @type {((inputs?: Team_Manager_DisabledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_DisabledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_disabled(inputs)
	if (locale === "de") return de_team_manager_disabled(inputs)
	if (locale === "it") return it_team_manager_disabled(inputs)
	if (locale === "ru") return ru_team_manager_disabled(inputs)
	if (locale === "es") return es_team_manager_disabled(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_disabled(inputs)
	if (locale === "ja") return ja_team_manager_disabled(inputs)
	if (locale === "hi") return hi_team_manager_disabled(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_disabled(inputs)
	return en_team_manager_disabled(inputs)
});